import { factory, sequence } from 'stahlwerk';

export const createTeam = factory({
  id: sequence(),
  crewId: sequence(),
  name: sequence((id) => `Team ${id}`),
});
